import template from './delivery_manifest_combined.html'
import controller from './delivery_manifest_combined.controller'
import './delivery_manifest_combined.scss'

let deliveryManifestCombinedComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default deliveryManifestCombinedComponent;


// WEBPACK FOOTER //
// ./client/app/components/route_control/delivery_manifest_combined/delivery_manifest_combined.component.js